import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import { VariableNameAndType, VariableValidation } from '../../types';
import Cols from '__components/Layout/Cols';
import type { AutomationVariableDataType } from 'pages/AutomationEngine/types';
import type { CheckVariableFromFieldCompatibilityFN } from '../../useVariableMetaData';

const TextWrapper = styled.div`
  margin-top: 10px;
`;

const validDataTypes: AutomationVariableDataType[] = [
  'date',
  'datetime',
  'string',
];

// simple true false by type
export const getFilteredValueSourceOptions = (
  _checkVariableTypeCompatabilty: CheckVariableFromFieldCompatibilityFN,
  variable: VariableNameAndType
) => {
  return validDataTypes.includes(variable?.dataType) ? validDataTypes : [];
};

// return a list of acceptable source options
export const getFilteredValueSourceOptionDetails = (
  _checkVariableTypeCompatabilty: CheckVariableFromFieldCompatibilityFN,
  variable: VariableNameAndType
) => {
  return validDataTypes.includes(variable?.dataType) ? validDataTypes : [];
};

export const Component = forwardRef((_values: any, ref) => {
  const { t } = useTranslation();

  return (
    <Cols columns={1} gutter="20px" ref={ref}>
      <TextWrapper>
        <KizenTypography>
          {t('Will be set to the time the agentic workflow is triggered')}
        </KizenTypography>
      </TextWrapper>
    </Cols>
  );
});

export const validate = ({ values, checkRequired, t }: VariableValidation) => {
  return {
    valid: true,
    errors: [],
  };
};
